import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareNotificationsIssueLogsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareNotificationsIssueLogsRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import {
	SoftwareNotificationsIssueLogs,
	LazySoftwareNotificationsIssueLogs,
	emailNotificationsLogEntryPointPage,
} from './ui/project-settings/software-notifications-issue-logs/index.tsx';

export const projectSettingsSoftwareNotificationsIssueLogsRouteEntry: Route = createEntry(
	projectSettingsSoftwareNotificationsIssueLogsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.software.notifications.issue-logs',
		// eslint-disable-next-line no-restricted-syntax
		component: SoftwareNotificationsIssueLogs,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazySoftwareNotificationsIssueLogs],

		entryPoint() {
			return emailNotificationsLogEntryPointPage;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
